import { api } from "app/data/api";
import { DepartmentList } from "app/views/register/institutionRequest/InstitutionRequestList";

export const listInstitution = async () => {
  return await api.get('institution/list', {})
}

export const registerInstitution = async (data) => {
  return await api.post("/institution/register", {
    ...data
  })
}

export const editInstitution = async (data) => {
  return await api.put("/institution/edit", {
    ...data
  })
}

export const requestInstitution = async (data) => {
  return await api.post("/institution/request", {
    ...data
  })
}

export const listRequestedInstitution = async (): Promise<DepartmentList> => {
  return await api.get("/institution/requestedList");
}

export const cancelRequest = async () => {
  return await api.delete("/institution/requestCancel")
}

export const deleteRequest = async (userRequestId: number, departmentRequestId: number) => {
  return await api.delete("/institution/deleteRequest", {
    params: {
      userRequestId,
      departmentRequestId
    }
  })
}

export const approveRequest = async (data: any) => {
  return await api.post("/institution/approveRequest", {
    ...data
  })
}